import { useState } from 'react';
import { CollapsibleContent } from '@schibsted-svp/react-ui';
import classNames from 'classnames';

import type { FC, ReactNode } from 'react';

import styles from './CollapsibleSection.module.scss';

type Props = {
  label: string;
  children?: ReactNode;
  initiallyCollapsed?: boolean;
  className?: string;
};

const CollapsibleSection: FC<Props> = ({
  label,
  children,
  initiallyCollapsed = true,
  className,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(initiallyCollapsed);

  return (
    <CollapsibleContent
      label={label}
      expanded={!isCollapsed}
      onToggle={() => {
        setIsCollapsed(!isCollapsed);
      }}
    >
      <div className={classNames(styles.container, className)}>{children}</div>
    </CollapsibleContent>
  );
};

export { CollapsibleSection };
